import { useSidebar } from '@ibsys/kit';
import { useCallback } from 'react';
import { useCopilot } from '@/features/copilot';
import { useMainLayout } from '@/shared/ui';

/**
 * Действия открытия панели ИИ-агента из сайдбара: перед переключением на список чатов
 * или созданием нового чата раскрывают свёрнутую до иконок панель контента (на десктопе).
 */
export const useCopilotPanelActions = () => {
  const { isMobile } = useMainLayout();
  const { setOpen } = useSidebar();
  const { createNewChat, showChatList } = useCopilot();

  const handleCreateNewChat = useCallback(() => {
    if (!isMobile) {
      setOpen(true);
    }
    createNewChat();
  }, [createNewChat, isMobile, setOpen]);

  const handleShowChatList = useCallback(() => {
    if (!isMobile) {
      setOpen(true);
    }
    showChatList();
  }, [isMobile, setOpen, showChatList]);

  return { handleCreateNewChat, handleShowChatList };
};
